import actionTypes from './actionTypes';

export const paying = payment => ({
  type: actionTypes.PAYING,
  payload: payment,
});

export const pay = payment => ({
  type: actionTypes.PAY,
  payload: payment,
});

export const paySuccess = (payload = {}) => ({
  type: actionTypes.PAY_SUCCESS,
  payload,
});

export const payFailed = errorMessage => ({
  type: actionTypes.PAY_FAILED,
  payload: {
    errorMessage,
  },
});

export const reset = () => ({
  type: actionTypes.RESET_PAYMENT,
});

export const selectCard = cardToken => ({
  type: actionTypes.SELECT_CARD,
  payload: {
    cardToken,
  },
});

export const confirm = url => ({
  type: actionTypes.CONFIRM,
  payload: {
    url,
  },
});
